<template>
    <div class="block-editor youtube-set-moderation-status">
        <section>
            <div class="title">Channel ID</div>
            <TiptapEditor placeholder="YouTube Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>Moderasyon yapılacak yorumun bulunduğu kanal ID'si</small>
        </section>
        <section>
            <div class="title">Comment ID</div>
            <TiptapEditor placeholder="YouTube Comment ID" :show-attributes="true" v-model="clone.commentId" automation-mode />
            <small>Moderasyon durumu değiştirilecek yorumun ID'si</small>
        </section>
        <section>
            <div class="title">Moderasyon Durumu</div>
            <a-select v-model="clone.moderationStatus" class="classic-select" placeholder="Moderasyon durumu seçiniz">
                <a-select-option value="published">Yayınla (published)</a-select-option>
                <a-select-option value="heldForReview">İncelemeye Al (heldForReview)</a-select-option>
                <a-select-option value="rejected">Reddet (rejected)</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">Yorum Sahibini Banla</div>
            <a-switch v-model="clone.banAuthor" />
            <small class="ban-warning" v-if="clone.banAuthor">Dikkat: Bu kullanıcı kanalınızda bir daha yorum yapamayacak</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "YouTubeSetModerationStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                commentId: "",
                moderationStatus: "published",
                banAuthor: false,
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.youtube-set-moderation-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
        
        &.ban-warning {
            color: #ff4d4f;
            font-weight: 500;
        }
    }
}
</style>
